/* eslint-disable */
/* tslint:disable */
// @ts-nocheck
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import { Injectable } from "@jkhy/frontend-utils/di";
import { TmHttpClient } from "@treasury/core/http";
import { createSwaggerClient } from "../../utils/tm-swagger-client";

import {
    CompanyModelCollectionDto,
    CompanySearchModelCompanyDto,
    ErrorHttpContentDto,
} from "../";
import { ContentType, HttpClient, RequestParams } from "./http-client";

@Injectable()
export class CompanyClient {
  private readonly http: HttpClient;

  constructor(tmHttp: TmHttpClient) {
    this.http = createSwaggerClient(tmHttp, HttpClient);
  }

  /**
   * No description
   *
   * @tags Company
   * @name CompanyGetCompanyGuidUniqueId
   * @summary Gets company guid unique id in exchange for an ID.
   * @request GET:/Company/GetGuidUniqueId/{companyId}
   */
  companyGetCompanyGuidUniqueId = (
    companyId: number,
    params: RequestParams = {},
  ) =>
    this.http.request<string, ErrorHttpContentDto | File>({
      path: `/Company/GetGuidUniqueId/${companyId}`,
      method: "GET",
      format: "json",
      ...params,
    });
  /**
   * No description
   *
   * @tags Company
   * @name CompanyCompanySearch
   * @summary Searches for companies that meet the criteria of the request.
   * @request POST:/Company/Search
   */
  companyCompanySearch = (
    data: CompanySearchModelCompanyDto,
    params: RequestParams = {},
  ) =>
    this.http.request<CompanyModelCollectionDto, ErrorHttpContentDto>({
      path: `/Company/Search`,
      method: "POST",
      body: data,
      type: ContentType.Json,
      format: "json",
      ...params,
    });
}
